/* ============================================================
   NOBS & CO — Header: drawer mobile (abrir/fechar + trava de scroll)
   O mega menu desktop é 100% CSS (hover/focus-within).
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-nobs-drawer]');
    if (!drawer) return;

    var openBtns = document.querySelectorAll('[data-nobs-drawer-open]');
    var closeEls = drawer.querySelectorAll('[data-nobs-drawer-close]');

    function open() {
      drawer.hidden = false;
      // força reflow pra transição rodar
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    initSearch();
  }

  /* ---------- busca (overlay pela lupa + sugestões) ---------- */
  function initSearch() {
    var search = document.querySelector('[data-nobs-search]');
    if (!search) return;

    var input = search.querySelector('[data-nobs-search-input]');
    var results = search.querySelector('[data-nobs-search-results]');
    var panel = search.querySelector('.nobs-search__panel');
    var openBtns = document.querySelectorAll('[data-nobs-search-open]');
    var closeEls = search.querySelectorAll('[data-nobs-search-close]');
    var timer = null;

    // posiciona o painel logo ABAIXO do cabeçalho (não cobrindo as faixas do topo)
    function placePanel() {
      if (!panel) return;
      var header = document.querySelector('.nobs-header');
      var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      panel.style.top = bottom + 'px';
    }

    function open() {
      placePanel();
      search.hidden = false;
      void search.offsetWidth;
      search.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      search.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { search.hidden = true; }, 260);
    }

    // a API /search/suggest.json retorna price já em reais como string ("197.00")
    function money(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      return 'R$ ' + n.toFixed(2).replace('.', ',');
    }

    function render(products) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = '<p class="nobs-search__empty">Nada encontrado. Tente outro termo.</p>';
        return;
      }
      results.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        return '<a class="nobs-search__item" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" width="52" height="52" loading="lazy">' : '<span class="nobs-search__item-noimg"></span>') +
          '<span class="nobs-search__item-info">' +
          '<span class="nobs-search__item-name">' + p.title + '</span>' +
          (p.price != null ? '<span class="nobs-search__item-price">' + money(p.price) + '</span>' : '') +
          '</span></a>';
      }).join('');
    }

    function suggest(q) {
      if (!q || q.length < 2) { if (results) results.innerHTML = ''; return; }
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products);
        })
        .catch(function () {});
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { suggest(q); }, 220);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !search.hidden) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
